<template>
  <div>
    <a-spin :spinning="loading">
      <!-- 批次基础信息卡片 -->
      <a-card :title="$t(I18N_KEY.PAYROLL + 'batchBaseInfo')" type="inner" style="margin-top: 24px;">
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'batchNo')">{{ batchNo }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'fileName')">{{ fileName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'createTime')">{{ createTime }}</detail-list-item>

          <!-- 修改：绑定动态计算的变量 -->
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'allCount')" v-if="isHrRole">{{ totalCount
          }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'allAmount')" v-if="isHrRole">{{ totalAmount
          }}</detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'effectiveCount')" v-if="isHrRole">
            {{ displayEffectiveCount }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'effectiveAmount')" v-if="isHrRole">
            {{ displayEffectiveAmount }}
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'rejectCount')" v-if="status === 3 && isHrRole">{{
            this.rejectDatas.length }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'rejectReason')" v-if="status === 3 && isHrRole">{{
            this.uniqueRemarks }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.PAYROLL + 'waitRejectCount')" v-if="isFinanceRole">{{
            this.selectedRowKeys.length }}</detail-list-item>
        </detail-list>
      </a-card>

      <!-- 明细查询区域 -->
      <a-card style="margin-top: 24px" type="inner">
        <!-- 查询表单 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchDetail">
            <a-row :gutter="24">
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY.PAYROLL + 'userNo')">
                  <a-input :placeholder="$t(I18N_KEY.PAYROLL + 'userNoPlaceholder')" v-model="detailQueryParam.mobile"
                    clearable />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY.PAYROLL + 'employeeName')">
                  <a-input :placeholder="$t(I18N_KEY.PAYROLL + 'employeeNamePlaceholder')"
                    v-model="detailQueryParam.employeeName" clearable />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY.PAYROLL + 'account')">
                  <a-input :placeholder="$t(I18N_KEY.PAYROLL + 'accountPlaceholder')" v-model="detailQueryParam.account"
                    clearable />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY.PAYROLL + 'groupId')">
                  <a-select v-model="detailQueryParam.groupId" placeholder="请选择分组" clearable>
                    <a-select-option v-for="item in groupList" :key="item.id" :value="item.id">
                      {{ item.groupName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="6">
                <a-form-item :label="$t(I18N_KEY.PAYROLL + 'status')">
                  <a-select v-model="detailQueryParam.status" allowClear
                    :placeholder="$t(I18N_KEY.PAYROLL + 'statusPlaceholder')" style="width: 100%;"
                    dropdownClassName="status-dropdown-fix" :getPopupContainer="trigger => trigger.parentNode">
                    <a-select-option :value="null">全部</a-select-option>
                    <a-select-option value="-1">已取消</a-select-option>
                    <a-select-option value="0">未提交</a-select-option>
                    <a-select-option value="1">待审核</a-select-option>
                    <a-select-option value="2">审核通过</a-select-option>
                    <a-select-option value="3">审核驳回</a-select-option>
                    <a-select-option value="4">放款失败</a-select-option>
                    <a-select-option value="5">放款成功</a-select-option>
                    <a-select-option value="6">放款中</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchDetail" style="margin-right: 8px"> {{ $t('search') }} </a-button>
                <a-button @click="resetDetailQuery" style="margin-right: 8px">{{ $t('reset') }}</a-button>
                <a-button @click="searchRejectData" style="margin-right: 8px" v-if="!this.isFinanceRole">{{
                  $t(I18N_KEY.PAYROLL + 'onlyRejectData') }}</a-button>
                <a-button @click="searchRejectData" style="margin-right: 8px" v-if="this.isFinanceRole">{{
                  $t(I18N_KEY.PAYROLL + 'waitRejectData') }}</a-button>
                <a-button type="primary" @click="openAddModal">{{ $t('add') }}</a-button>
              </a-col>
            </a-row>
          </a-form>

          <!-- 明细列表 -->
          <a-table :columns="detailColumns" :data-source="detailDataSource" :pagination="{
            ...detailPagination,
            showQuickJumper: true,
            disabled: detailLoading
          }" :loading="detailLoading" rowKey="detailId" style="margin-top: 16px" :row-selection="isHrRole ? null : {
            selectedRowKeys: selectedRowKeys,
            onChange: handleSelectChange,
            getCheckboxProps: getTableCheckboxProps
          }">
            <!-- 修改：状态列使用 Badge -->
            <template slot="status" slot-scope="text">
              <a-badge :status="getBadgeStatus(text)" :text="getStatusText(text)" />
            </template>

            <!-- 姓名列编辑模板 -->
            <template slot="employeeName" slot-scope="text, record">
              <template v-if="editableKeys.includes(record.detailId)">
                <a-input v-model="editForm[record.detailId].employeeName" placeholder="请输入姓名" style="width: 120px"
                  @blur="handleEditBlur(record, 'employeeName')" />
              </template>
              <template v-else>
                {{ text || '-' }}
              </template>
            </template>

            <!-- 账号列渲染 -->
            <template slot="account" slot-scope="text, record">
              <template v-if="editableKeys.includes(record.detailId)">
                <a-input v-model="editForm[record.detailId].account" placeholder="请输入账号" style="width: 120px"
                  @blur="handleEditBlur(record, 'account')" @input="handleAmountInput(record)" />
              </template>
              <template v-else>
                {{ text || '-' }}
              </template>
            </template>

            <!-- 金额列编辑模板 -->
            <template slot="amount" slot-scope="text, record">
              <template v-if="editableKeys.includes(record.detailId)">
                <a-input v-model="editForm[record.detailId].amount" placeholder="请输入金额" style="width: 120px"
                  @blur="handleEditBlur(record, 'amount')" />
              </template>
              <template v-else>
                {{ (text || 0).toFixed(2) }}
              </template>
            </template>

            <!-- 操作列自定义渲染 -->
            <template slot="action" slot-scope="text, record" v-if="!isFinanceRole">
              <template v-if="record.status === 0 || record.status === 3 || record.status === 4">
                <a-button type="primary" size="small" style="margin-right: 8px" @click="handleEdit(record)"
                  :loading="detailLoading && editableKeys.includes(record.detailId)"
                  :disabled="detailLoading && editableKeys.includes(record.detailId) && showAduit">
                  {{ editableKeys.includes(record.detailId) ? '确认' : '编辑' }}
                </a-button>
                <a-button size="small" style="margin-right: 8px" @click="handleCancelPay(record)"
                  :disabled="showAduit">取消发薪</a-button>
              </template>
              <template v-else-if="record.status === 1">
                <a-button size="small" style="margin-right: 8px" :disabled="true"
                  @click="handleCancelPay(record)">取消发薪</a-button>
              </template>
              <template v-else-if="record.status === -1">
                <a-button type="primary" size="small" :disabled="showAduit" @click="handleRecover(record)">恢复</a-button>
              </template>
              <template v-else>
                <span style="color: #999;">--</span>
              </template>
            </template>
          </a-table>
        </div>
      </a-card>

      <!-- 批量操作按钮 -->
      <div style="margin-top: 16px; text-align: right">
        <a-button type="primary" @click="handleSubmitAudit" style="margin-right: 8px" v-if="!this.isFinanceRole"
          :disabled="submitLoading">
          提交审核
        </a-button>
        <a-button @click="handleCancelBatch" v-if="!this.isFinanceRole">取消整个批次</a-button>
        <template v-if="isFinanceRole && isShowFinanceAction">
          <a-tooltip :title="selectedRowKeys.length !== 0 ? '请先取消勾选或处理驳回项' : null" placement="top">
            <a-button type="primary" @click="handlePassAudit" style="margin-right: 8px"
              :disabled="selectedRowKeys.length !== 0" :loading="passLoading">
              审核通过并放款
            </a-button>
          </a-tooltip>
        </template>

        <!-- 修改：驳回按钮文字动态变化 -->
        <a-button type="primary" @click="handleRejectAudit" style="margin-right: 8px"
          v-if="this.isFinanceRole && isShowFinanceAction" :disabled="selectedRowKeys.length === 0">
          {{ selectedRowKeys.length > 0 ? '驳回(' + selectedRowKeys.length + ')' : '驳回选中项' }}
        </a-button>
      </div>

      <!-- 新增记录弹窗 -->
      <a-modal title="手动添加发薪记录" :visible="showAddModal" :footer="null" @cancel="resetAndCloseAddModal" width="600px"
        centered>
        <a-spin :spinning="addLoading" tip="正在提交，请稍候...">
          <div class="add-form-container" style="padding: 10px;">
            <div class="form-item" style="margin-bottom: 16px;">
              <label class="form-label" style="display: block; margin-bottom: 8px; font-weight: 500;">
                催收员工账号 <span style="color: red">*</span>
              </label>
              <a-select v-model='addForm.employeeId' allowClear placeholder="请选择催收员工账号" style="width: 100%;">
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </div>

            <div class="form-item" style="margin-bottom: 16px;">
              <label class="form-label" style="display: block; margin-bottom: 8px; font-weight: 500;">
                发薪银行账号 <span style="color: red">*</span>
              </label>
              <a-input v-model="addForm.account" placeholder="请输入发薪银行账号" style="width: 100%;" />
            </div>

            <div class="form-item" style="margin-bottom: 16px;">
              <label class="form-label" style="display: block; margin-bottom: 8px; font-weight: 500;">
                银行账号类型
              </label>
              <a-input v-model="addForm.accountType" placeholder="请输入银行账号类型" style="width: 100%;" />
            </div>

            <div class="form-item" style="margin-bottom: 16px;">
              <label class="form-label" style="display: block; margin-bottom: 8px; font-weight: 500;">
                发薪金额 <span style="color: red">*</span>
              </label>
              <a-input v-model="addForm.amount" placeholder="请输入发薪金额（如：100 或 100.50）" style="width: 100%;"
                @input="handleAddAmountInput" />
            </div>

            <div class="form-item" style="text-align: right; margin-top: 20px;">
              <a-button type="primary" @click="handleAddSubmit" style="margin-right: 8px" :loading="addLoading"
                :disabled="addLoading">提交</a-button>
              <a-button @click="resetAndCloseAddModal">取消</a-button>
            </div>
          </div>
        </a-spin>

      </a-modal>

      <!-- 驳回选中项弹窗 -->
      <a-modal title="驳回选中项" :visible="showRejectModal" :footer="null" @cancel="handleRejectCancel" width="500px"
        centered>
        <!-- 👇 添加 a-spin 包裹表单，绑定 rejectLoading -->
        <a-spin :spinning="rejectLoading" tip="正在提交驳回...">
          <a-form :model="rejectForm" layout="vertical">
            <a-form-item label="驳回原因" required>
              <a-textarea v-model="rejectForm.rejectReason" placeholder="请输入驳回原因" rows="4" maxlength="500" show-count
                @change="handleRejectReasonChange" :disabled="rejectLoading" />
              <span v-if="rejectFormError" style="color: #f5222d; font-size: 12px; margin-top: 4px; display: block;">
                {{ rejectFormError }}
              </span>
            </a-form-item>
            <a-form-item label="提示信息">
              <div style="color: #faad14;">
                即将驳回选中的 <strong>{{ selectedRowKeys.length }}</strong> 条数据，请确认！
              </div>
            </a-form-item>
            <a-form-item>
              <!-- 按钮也加上 disabled 状态，防止重复点击 -->
              <a-button type="primary" @click="handleRejectSubmit" style="margin-right: 8px" :loading="rejectLoading"
                :disabled="rejectLoading">
                确认驳回
              </a-button>
              <a-button @click="handleRejectCancel" :disabled="rejectLoading">取消</a-button>
            </a-form-item>
          </a-form>
        </a-spin>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import {
  queryPayrollDetail,
  addPayrollDetail,
  savePayrollDetail,
  cancelPayroll,
  recoverPayroll,
  passPayroll,
  submitAudit,
  cancelBatch,
  rejectAudit
} from '@/webpublicapi/payroll'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { DetailList } from '@/components'
import { mapActions } from 'vuex'
import Dict from '../modules/Dict'
import { getCollectorName } from '@/webpublicapi/collection'

const DetailListItem = DetailList.Item
const I18N_KEY = {
  PAYROLL: 'payroll.',
  CUSTOMER: 'customer.'
}

export default {
  name: 'PayrollDetail',
  props: {
    id: {
      type: [String, Number],
      default: null,
      required: true
    },
    batchNo: {
      type: [String, Number],
      default: null
    },
    fileName: {
      type: [String, Number],
      default: null
    },
    createTime: {
      type: [String, Number],
      default: null
    },
    totalCount: {
      type: [String, Number],
      default: null
    },
    totalAmount: {
      type: [String, Number],
      default: null
    },
    effectiveCount: {
      type: [String, Number],
      default: null
    },
    effectiveAmount: {
      type: [String, Number],
      default: null
    },
    rejectCount: {
      type: [String, Number],
      default: null
    },
    rejectReason: {
      type: [String, Number],
      default: null
    },
    waitRejectCount: {
      type: [String, Number],
      default: null
    },
    status: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    DetailList,
    DetailListItem,
    Dict
  },
  data() {
    return {
      I18N_KEY,
      loading: false,
      rejectLoading: false,
      submitLoading: false,
      passLoading: false,
      isShowFinanceAction: false,
      addLoading: false,
      showAduit: false,
      showAddModal: false,
      isFinanceRole: false,
      isHrRole: false,
      selectedRowKeys: [],
      groupList: [],
      CollectorNameList: [],
      editableKeys: [],
      rejectDatas: [],
      uniqueRemarks: '',
      editForm: {},
      rowLoading: {},
      showRejectModal: false,
      rejectForm: {
        rejectReason: ''
      },
      rejectFormError: '',

      // 新增：用于前端实时显示的变量
      displayEffectiveCount: 0,
      displayEffectiveAmount: 0,

      detailQueryParam: {
        mobile: null,
        employeeName: null,
        account: null,
        groupId: null,
        status: null
      },

      detailLoading: false,
      detailDataSource: [],
      detailPagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total) => `共 ${total} 条数据`,
        onChange: (page, pageSize) => {
          this.detailPagination.current = page;
          this.detailPagination.pageSize = pageSize;
          // this.searchDetail();
        },
        showSizeChange: (current, pageSize) => {
          this.detailPagination.current = 1;
          this.detailPagination.pageSize = pageSize;
          // this.searchDetail();
        }
      },

      addForm: {
        employeeId: '',
        account: '',
        accountType: '',
        amount: ''
      }
    }
  },
  computed: {
    detailColumns() {
      const baseColumns = [
        {
          title: '催收员账号',
          dataIndex: 'mobile',
          align: 'center',
          width: '100px'
        },
        {
          title: '催收员姓名',
          dataIndex: 'employeeName',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'employeeName' }
        },
        {
          title: '分组',
          dataIndex: 'groupName',
          align: 'center',
          width: '120px'
        },
        {
          title: '发薪银行账号',
          dataIndex: 'account',
          align: 'center',
          width: '180px',
          scopedSlots: { customRender: 'account' }
        },
        {
          title: '发薪金额',
          dataIndex: 'amount',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        }
      ];

      if (!this.isFinanceRole) {
        baseColumns.push(
          {
            title: '更新时间',
            dataIndex: 'updateTime',
            align: 'center',
            width: '180px',
            customRender: (text) => text || '-'
          },
          {
            title: '操作',
            align: 'center',
            width: '150px',
            scopedSlots: { customRender: 'action' }
          }
        );
      }

      return baseColumns;
    }
  },
  created() {
    this.initPage().then(() => {
      this.filterInvalidSelectedRows();
    });
    getCollectorName().then(res => {
      if (res.data) {
        const keys = Object.keys(res.data);
        keys.forEach(key => {
          this.CollectorNameList.push({
            key: key,
            value: res.data[key]
          });
        });
      }
    });
  },
  methods: {
    ...mapActions('payroll', ['getPayrollDetail']),

    resetAddForm() {
      this.addForm = {
        batchId: null,
        employeeId: '',
        employeeName: '',
        account: '',
        accountType: '',
        amount: '',
        status: 0
      };
    },

    openAddModal() {
      this.resetAddForm();
      this.addLoading = false;
      this.showAddModal = true;
    },

    resetAndCloseAddModal() {
      this.resetAddForm();
      this.addLoading = false;
      this.showAddModal = false;
    },

    async initPage() {
      this.loading = true;
      try {
        await Promise.all([
          this.isRoleCode(),
          this.getGroupList(),
          this.searchDetail()
        ]);

        // 初始化时：如果还没有数据（第一次加载），先使用 Props 传过来的值
        // searchDetail 完成后会再次计算覆盖，这里主要是为了在 searchDetail 完成前的瞬间有值
        this.displayEffectiveCount = Number(this.effectiveCount) || 0;
        this.displayEffectiveAmount = Number(this.effectiveAmount) || 0;
      } catch (error) {
        this.$message.error('页面初始化失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },

    async getGroupList() {
      try {
        const res = await getSysGroup();
        this.groupList = res.data || [];
      } catch (error) {
        this.$message.error('获取分组列表失败：' + error.message);
        this.groupList = [];
      }
    },

    // 新增：计算有效条数和有效金额的方法
    calculateEffectiveData() {
      // 定义“有效”：状态不等于 -1 (已取消)
      // 根据你的截图逻辑，只要不是“已取消”，都算在有效条数和金额里
      const validRecords = this.detailDataSource.filter(record => {
        const status = Number(record.status);
        return status !== -1;
      });

      const count = validRecords.length;
      const amount = validRecords.reduce((sum, record) => {
        return sum + (Number(record.amount) || 0);
      }, 0);

      this.displayEffectiveCount = count;
      this.displayEffectiveAmount = amount.toFixed(2);
    },

    filterInvalidSelectedRows() {
      if (!this.detailDataSource.length) return;
      this.selectedRowKeys = this.selectedRowKeys.filter(detailId => {
        const record = this.detailDataSource.find(item => item.detailId === detailId);
        if (!record) return false;
        const status = Number(record.status);
        return [1, 3].includes(status);
      });
    },

    getTableCheckboxProps(record) {
      const status = Number(record.status) || -99;
      const isEnable = [1].includes(status);
      return {
        disabled: !isEnable,
        value: record.detailId,
        checked: isEnable ? this.selectedRowKeys.includes(record.detailId) : false
      };
    },

    isRoleCode() {
      return new Promise((resolve) => {
        try {
          const roleCodeStr = localStorage.getItem('roleCodes');
          const roleCodeArray = JSON.parse(roleCodeStr || '[]');
          this.isFinanceRole = Array.isArray(roleCodeArray) && roleCodeArray.includes('finance_user');
          this.isHrRole = Array.isArray(roleCodeArray) && roleCodeArray.includes('hr_user');
        } catch (e) {
          this.isFinanceRole = false;
          this.isHrRole = false;
        }
        resolve();
      });
    },

    handleSelectChange(selectedRowKeys) {
      const validKeys = selectedRowKeys.filter(detailId => {
        const record = this.detailDataSource.find(item => item.detailId === detailId);
        if (!record) return false;
        const status = Number(record.status);
        return [1].includes(status);
      });
      this.selectedRowKeys = validKeys;
    },

    handleEdit(record) {
      const index = this.editableKeys.indexOf(record.detailId);
      if (index > -1) {
        this.handleSave(record);
        this.editableKeys.splice(index, 1);
      } else {
        if (!this.editForm[record.detailId]) {
          this.editForm[record.detailId] = {
            employeeName: record.employeeName || '',
            account: record.account || '',
            amount: (record.amount || 0).toString()
          };
        }
        this.editableKeys.push(record.detailId);
      }
      this.$set(this.rowLoading, record.detailId, false);
    },

    handleAmountInput(record) {
      let amount = this.editForm[record.detailId].amount || '';
      amount = amount.replace(/[^0-9.]/g, '');
      const dotIndex = amount.indexOf('.');
      if (dotIndex > -1) {
        amount = amount.slice(0, dotIndex + 1) + amount.slice(dotIndex + 1).replace(/\./g, '');
      }
      if (dotIndex > -1 && amount.slice(dotIndex + 1).length > 2) {
        amount = amount.slice(0, dotIndex + 3);
      }
      this.editForm[record.detailId].amount = amount;
    },

    handleAddAmountInput() {
      if (this.addForm.amount) {
        this.addForm.amount = this.addForm.amount.replace(/[^0-9.]/g, '');
      }
    },

    handleEditBlur(record, field) {
      if (field === 'amount') {
        const rawAmount = this.editForm[record.detailId]?.amount;
        if (!rawAmount || rawAmount.trim() === '') {
          this.$message.warning(`行 ${record.detailId}：金额不能为空`);
          return;
        }
        const numAmount = Number(rawAmount.trim());
        if (numAmount <= 0) {
          this.$message.warning(`行 ${record.detailId}：金额必须大于 0`);
          return;
        }
        const amountReg = /^(\d+)(\.\d{1,2})?$/;
        if (!amountReg.test(rawAmount.trim())) {
          this.$message.warning(`行 ${record.detailId}：金额格式错误！仅支持数字，小数点后最多 2 位`);
          return;
        }
      }
      if (field === 'employeeName' && !this.editForm[record.detailId]?.employeeName?.trim()) {
        this.$message.warning(`行 ${record.detailId}：姓名不能为空`);
      }
      if (field === 'account' && !this.editForm[record.detailId]?.account?.trim()) {
        this.$message.warning(`行 ${record.detailId}：账号不能为空`);
      }
    },

    async searchDetail() {
      if (!this.id) {
        this.$message.warning('批次 ID 不能为空');
        return;
      }

      this.detailLoading = true;
      try {
        const params = {
          batchId: this.id,
          mobile: this.detailQueryParam.mobile,
          employeeName: this.detailQueryParam.employeeName,
          account: this.detailQueryParam.account,
          groupId: this.detailQueryParam.groupId,
          status: this.detailQueryParam.status,
          pageNum: null,
          pageSize: null
        };

        const res = await queryPayrollDetail(params);
        if (res.code === 1000) {
          this.detailDataSource = res.data.rows || [];
          this.detailPagination.total = res.data.total || 0;
          this.selectedRowKeys = this.selectedRowKeys.filter(detailId => {
            const record = this.detailDataSource.find(item => item.detailId === detailId);
            if (!record) return false;
            const status = Number(record.status);
            return [1, 3].includes(status);
          });

          this.rejectDatas = this.detailDataSource
            .filter(record => Number(record.status) === 3) // 先筛选出状态为 3 的记录
            .map(record => record.detailId);

          console.log(this.rejectDatas, "ssdasd");
          this.uniqueRemarks = [...new Set(this.detailDataSource.map(item => item.remark))]
            .filter(r => r) // 可选：过滤掉空字符串或 null/undefined
            .join(';'); // isShowFinanceAction

          const waitPassData = this.detailDataSource
            .filter(record => Number(record.status) === 1) // 先筛选出状态为 3 的记录
            .map(record => record.detailId);

          if (waitPassData.length) {
            this.isShowFinanceAction = true;
          } else {
            this.isShowFinanceAction = false;
          }


          // 查询成功后，重新计算有效数据
          this.calculateEffectiveData();
        } else {
          this.$message.error(res.msg || '查询失败');
          this.detailDataSource = [];
          this.detailPagination.total = 0;
        }
      } catch (e) {
        this.$message.error('查询明细失败：' + e.message);
        this.detailDataSource = [];
        this.detailPagination.total = 0;
      } finally {
        this.detailLoading = false;
        this.editableKeys = [];
      }
    },

    resetDetailQuery() {
      this.detailQueryParam = {
        mobile: null,
        employeeName: null,
        account: null,
        groupId: null,
        status: null
      };
      this.detailPagination = {
        ...this.detailPagination,
        current: 1,
        pageSize: 10
      };
      this.searchDetail();
    },

    searchRejectData() {
      this.detailQueryParam.status = '3';
      this.detailPagination = {
        ...this.detailPagination,
        current: 1,
        pageSize: 10
      };
      this.searchDetail();
    },

    async handleSave(record) {
      try {
        if (this.isFinanceRole) {
          this.$message.warning('财务角色不能修改信息，请联系 HR');
          return;
        }

        if (!this.editForm[record.detailId]?.employeeName?.trim()) {
          this.$message.warning('姓名不能为空');
          return;
        }

        if (!this.editForm[record.detailId]?.account?.trim()) {
          this.$message.warning('账号不能为空');
          return;
        }

        const rawAmount = this.editForm[record.detailId]?.amount;
        if (!rawAmount || rawAmount.trim() === '') {
          this.$message.warning('金额不能为空');
          return;
        }
        const numAmount = Number(rawAmount.trim());
        if (numAmount <= 0) {
          this.$message.warning('金额必须大于 0');
          return;
        }
        const amountReg = /^(\d+)(\.\d{1,2})?$/;
        if (!amountReg.test(rawAmount.trim())) {
          this.$message.warning('金额格式错误！仅支持数字，小数点后最多 2 位');
          return;
        }

        this.detailLoading = true;
        const saveParams = {
          detailId: record.detailId,
          employeeName: this.editForm[record.detailId].employeeName,
          account: this.editForm[record.detailId].account,
          amount: numAmount,
          status: 0
        };

        const res = await savePayrollDetail(saveParams);
        if (res.code === 1000) {
          this.$message.success(res.msg);
          await this.searchDetail(); // 刷新列表并重新计算
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.$message.error('保存失败：' + e.message);
      } finally {
        this.detailLoading = false;
      }
    },

    handleCancelPay(record) {
      this.$confirm({
        title: '提示',
        content: '确定取消该员工的本次发薪吗？',
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        onOk: async () => {
          try {
            const updateParams = {
              detailId: record.detailId,
              batchId: this.id,
              status: -1
            };

            const res = await savePayrollDetail(updateParams);
            if (res.code === 1000) {
              this.$message.success(res.msg);
              await this.searchDetail(); // 刷新列表并重新计算
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            this.$message.error('取消发薪失败：' + e.message);
          }
        }
      });
    },

    handleRecover(record) {
      this.$confirm({
        title: '提示',
        content: '确定恢复该员工的本次发薪吗？',
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        onOk: async () => {
          try {
            const updateParams = {
              detailId: record.detailId,
              status: 0
            };

            const res = await savePayrollDetail(updateParams);
            if (res.code === 1000) {
              this.$message.success(res.msg);
              await this.searchDetail(); // 刷新列表并重新计算
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            if (e !== 'cancel') {
              this.$message.error('恢复失败：' + e.message);
            }
          }
        }
      });
    },

    async handleSubmitAudit() {
      this.submitLoading = true;
      this.showAduit = true;
      try {
        const allTableData = this.detailDataSource;
        const batchId = this.id;

        if (!batchId) {
          this.$message.warning('批次 ID 不能为空');
          this.submitLoading = false;
          this.showAduit = false;
          return;
        }

        const waitPassList = allTableData
          .filter(item => {
            const status = Number(item.status);
            return [0, 4].includes(status);
          })
          .map(item => item.detailId);

        if (waitPassList.length === 0) {
          this.$message.warning('暂无可提交审核的记录');
          this.submitLoading = false;
          this.showAduit = false;
          return;
        }

        const hasRejectData = allTableData.some(item => Number(item.status) === 3);
        if (hasRejectData) {
          this.$message.warning(`仍有${allTableData.filter(item => Number(item.status) === 3).length}条数据处于“驳回”状态未修正`);
        } else {
          this.$confirm({
            title: '提示',
            content: `确认提交数据审核吗？`,
            okText: '确定',
            cancelText: '取消',
            type: 'warning',
            onOk: async () => {
              const res = await submitAudit({
                batchId: batchId,
                passPayList: waitPassList
              });

              if (res.code === 1000) {
                this.$message.success(res.msg);
                await this.searchDetail(); // 刷新列表并重新计算
                this.selectedRowKeys = [];
              } else {
                this.$message.error(res.msg || '提交审核失败');
              }
            }
          });
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('提交审核失败：' + (e.message || e));
        }
      } finally {
        this.submitLoading = false;
        this.showAduit = false;
      }
    },

    handlePassAudit() {
      const pendingAuditIds = this.detailDataSource
        .filter(item => Number(item.status) === 1)
        .map(item => item.detailId);

      if (pendingAuditIds.length === 0) {
        this.$message.warning('当前筛选条件下无待审核的数据');
        return;
      }

      // const noPassDetailIds = this.detailDataSource
      //   .filter(item => Number(item.status) === 3)
      //   .map(item => item.detailId);

      // if (noPassDetailIds.length !== 0) {
      //   this.$message.warning("当前批次内存在'驳回'数据,请联系HR修改");
      //   return;
      // }

      this.$confirm({
        title: '是否通过并放款',
        content: `即将通过当前筛选下的 ${pendingAuditIds.length} 条待审核数据，并放款，确认后不可撤回。`,
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        onOk: async () => {
          try {
            this.passLoading = true;
            const res = await passPayroll({
              batchId: this.id,
              detailIds: pendingAuditIds
            });
            if (res.code === 1000) {
              this.$message.success(res.msg);
              await this.searchDetail(); // 刷新列表并重新计算
              this.selectedRowKeys = [];
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            if (e !== 'cancel') {
              this.$message.error('提交审核失败：' + e.message);
            }
          } finally {
            this.passLoading = false;
          }
        }
      });
    },

    handleCancelBatch() {
      const allTableData = this.detailDataSource;
      const noCancelData = allTableData
        .filter(item => {
          const status = Number(item.status);
          return ![-1].includes(status);
        })
        .map(item => item.detailId);

      if (noCancelData.length === 0) {
        this.$message.warning('当前数据已全部取消');
        return;
      }

      this.$confirm({
        title: '警告',
        content: `确认取消整个批次的发薪任务吗？所有数据将作废`,
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        onOk: async () => {
          try {
            const batchId = this.id;
            const status = -1;
            const res = await savePayrollDetail({
              batchId: batchId,
              status: status
            });
            if (res.code === 1000) {
              this.$message.success(res.msg);
              await this.searchDetail(); // 刷新列表并重新计算
              this.$emit('batchCanceled', this.id);
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            if (e !== 'cancel') {
              this.$message.error('取消批次失败：' + e.message);
            }
          }
        }
      });
    },

    handleRejectAudit() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择需要驳回的记录');
        return;
      }
      this.rejectForm = { rejectReason: '' };
      this.rejectFormError = '';
      this.showRejectModal = true;
    },

    handleRejectCancel() {
      this.showRejectModal = false;
      this.rejectFormError = '';
      this.rejectForm.rejectReason = '';
    },

    handleRejectReasonChange() {
      this.rejectFormError = '';
    },

    async handleRejectSubmit() {
      if (!this.rejectForm.rejectReason || this.rejectForm.rejectReason.trim() === '') {
        this.rejectFormError = '请输入驳回原因';
        this.$message.warning('请完善必填字段');
        return;
      }

      try {
        this.rejectLoading = true;
        const rejectParams = {
          batchId: this.id,
          detailIds: this.selectedRowKeys,
          rejectReason: this.rejectForm.rejectReason.trim()
        };

        const res = await rejectAudit(rejectParams);
        if (res.code === 1000) {
          this.rejectLoading = false;
          this.$message.success(res.msg);
          this.handleRejectCancel();
          await this.searchDetail(); // 刷新列表并重新计算
          this.selectedRowKeys = [];
        } else {
          this.rejectLoading = false;
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.rejectLoading = false;
        if (e !== 'cancel') {
          this.$message.error('驳回失败：' + (e.message || '操作取消'));
        }
      }
    },

    async handleAddSubmit() {
      const errors = [];

      if (!this.addForm.employeeId && this.addForm.employeeId !== 0) {
        errors.push('请选择员工姓名');
      }

      if (!this.addForm.account || this.addForm.account.trim() === '') {
        errors.push('请输入账号');
      }

      if (!this.addForm.amount || this.addForm.amount.trim() === '') {
        errors.push('请输入金额');
      } else {
        const numAmount = Number(this.addForm.amount.trim());
        if (isNaN(numAmount) || numAmount <= 0) {
          errors.push('金额必须大于 0');
        }

        const amountReg = /^(\d+)(\.\d{1,2})?$/;
        if (!amountReg.test(this.addForm.amount.trim())) {
          errors.push('金额格式错误！仅支持数字，小数点后最多 2 位');
        }
      }

      if (errors.length > 0) {
        this.$message.error(errors.join(';'));
        return;
      }

      try {
        const addParams = {
          ...this.addForm,
          batchId: this.id,
          status: 0
        };

        this.addLoading = true;
        const res = await addPayrollDetail(addParams);
        if (res.code === 1000) {
          this.$message.success('新增成功');
          this.resetAndCloseAddModal();
          await this.searchDetail(); // 刷新列表并重新计算
        } else {
          this.$message.error(res.msg || '新增失败');
        }
      } catch (e) {
        this.$message.error('新增失败：' + e.message);
      } finally {
        this.addLoading = false;
      }
    },

    // 新增：辅助方法 - 获取 Badge 状态
    getBadgeStatus(value) {
      if (value === undefined || value === null) return 'default';
      const statusNum = Number(value);
      switch (statusNum) {
        case -1: return 'default';
        case 0: return 'warning';
        case 1: return 'processing';
        case 2: return 'success';
        case 3: return 'error';
        case 4: return 'error';
        case 5: return 'success';
        case 6: return 'processing';
        default: return 'default';
      }
    },

    // 新增：辅助方法 - 获取状态文字
    getStatusText(value) {
      if (value === undefined || value === null) return '未知状态';
      const statusNum = Number(value);
      const statusMap = {
        '-1': '已取消',
        '0': '未提交',
        '1': '待审核',
        '2': '审核通过',
        '3': '审核驳回',
        '4': '放款失败',
        '5': '放款成功',
        '6': '放款中'
      };
      return statusMap[String(statusNum)] || '未知状态';
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .description-list .content {
  font-weight: 700;
}

.table-page-search-wrapper {
  padding: 16px;
  background: #fff;
  border-radius: 2px;
}

/deep/ .ant-table-tbody>tr>td {
  padding: 8px 16px;
}

/deep/ .ant-input,
/deep/ .ant-input-number {
  border-radius: 4px;
}

.add-form-container {
  .form-item {
    margin-bottom: 16px;

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
    }
  }
}

/deep/ .status-dropdown-fix {
  /* 1. 强制设置最大高度，防止内容过多导致计算异常 */
  max-height: 300px !important;

  /* 2. 确保内部可滚动 */
  overflow-y: auto !important;

  /* 3. 关键：阻止滚动事件冒泡给父元素 (解决穿透) */
  overscroll-behavior: contain !important;

  /* 4. 提升层级，防止被遮挡 */
  z-index: 1050 !important;
}

/* 针对 Ant Design Vue 下拉菜单内部列表的额外修复 */
/deep/ .status-dropdown-fix .ant-select-dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto !important;
  overscroll-behavior: contain !important;
}
</style>